import dayjs from 'dayjs';

/** "Today 6:30 PM" / "Yesterday 4:12 PM" / "12/Mar/2026" — in the viewer's local time. */
export const formatUpdatedAt = (iso?: string): string | undefined => {
  if (!iso) {
    return undefined;
  }
  const date = dayjs(iso);
  if (!date.isValid()) {
    return undefined;
  }
  if (date.isSame(dayjs(), 'day')) {
    return `Today ${date.format('h:mm A')}`;
  }
  if (date.isSame(dayjs().subtract(1, 'day'), 'day')) {
    return `Yesterday ${date.format('h:mm A')}`;
  }
  return date.format('DD/MMM/YYYY');
};
